import { isCoreXQuery, getFeatureEnabled, isMobileQuery, magicConfig, SessionChange, MagicConfigMixin, ModalMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { MessagePriority, MessageStatus } from '@gig/magic-sdk/dist/adapter/messages/message';
import { magic } from '@gig/magic-sdk';
import { isHidden, isResponsibleGamingAlert } from '../../util/messages.js';
import { createElement } from '../../util/dom.js';
import { MESSAGING_LOADED, MESSAGING_LIST, Feature } from '@gig/magic-messages';
import { NotificationStyle, NotificationDelay } from '../../services/notifications/notifications.constants.js';
import '../../services/notifications/notification.js';
import { notificationService } from '../../services/notifications/notifications.service.js';
import '../../services/live-chat/live-chat.service.js';

/**
 * Prompts a messages modal when a responsible gaming
 * message has been received by the system.
 */
var MessagePrompterComponent = /** @class */ (function (_super) {
    __extends(MessagePrompterComponent, _super);
    function MessagePrompterComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openMessageId = '';
        /**
         * List of messages
         */
        _this.messages = [];
        _this.overlay = null;
        _this.isCoreX = false;
        return _this;
    }
    MessagePrompterComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.messageSubscription = window.eventBus.subscribe(MESSAGING_LOADED, function (event) { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!event.payload) {
                                            this.messages = [];
                                            return [2 /*return*/];
                                        }
                                        _a = this;
                                        return [4 /*yield*/, window.queryBus.query(MESSAGING_LIST)];
                                    case 1:
                                        _a.messages = _b.sent();
                                        return [4 /*yield*/, this.checkMessages()];
                                    case 2:
                                        _b.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, { replay: true });
                        _a = this;
                        return [4 /*yield*/, isCoreXQuery()];
                    case 1:
                        _a.isCoreX = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MessagePrompterComponent.prototype.onDisableAlertsChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkMessages()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MessagePrompterComponent.prototype.destroyed = function () {
        var _a;
        (_a = this.messageSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.removeOverlay();
    };
    MessagePrompterComponent.prototype.createOverlay = function () {
        this.removeOverlay();
        var overlay = createElement('div', {
            id: 'osm-overlay',
            styles: {
                position: 'fixed',
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                pointerEvents: 'auto',
            },
            parent: document.body,
        });
        this.overlay = overlay;
        return overlay;
    };
    MessagePrompterComponent.prototype.removeOverlay = function () {
        var existingOverlay = document.getElementById('osm-overlay') || this.overlay;
        if (existingOverlay) {
            document.body.removeChild(existingOverlay);
            this.overlay = null;
        }
    };
    Object.defineProperty(MessagePrompterComponent.prototype, "hasPopOpenMessage", {
        get: function () {
            return this.messages.some(function (message) {
                return message.priority === MessagePriority.POP_OPEN &&
                    !isHidden(message);
            });
        },
        enumerable: false,
        configurable: true
    });
    MessagePrompterComponent.prototype.checkMessages = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isMobile, useModalsOnMobile, hasModalOpen, hasResponsibleGamingAlert, messagesToShow, responsibleGamingAlert, message_1, isPopOpen, shouldUseNotification, notificationElement, overlay, notification_1, modalElement, modalElement;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, isMobileQuery()];
                    case 1:
                        isMobile = _a.sent();
                        return [4 /*yield*/, getFeatureEnabled(Feature.POP_OPEN_MESSAGES_AS_MODALS)];
                    case 2:
                        useModalsOnMobile = _a.sent();
                        if (this.shouldDisableAlerts && !this.hasPopOpenMessage) {
                            return [2 /*return*/];
                        }
                        hasModalOpen = false;
                        hasResponsibleGamingAlert = false;
                        messagesToShow = this.messages.filter(function (message) {
                            return message.status === MessageStatus.NEW &&
                                (isResponsibleGamingAlert(message) ||
                                    message.priority === MessagePriority.POP_OPEN);
                        });
                        if (messagesToShow.length > 0) {
                            responsibleGamingAlert = messagesToShow.filter(function (message) {
                                return isResponsibleGamingAlert(message);
                            });
                            if (responsibleGamingAlert.length > 0) {
                                hasResponsibleGamingAlert = true;
                                message_1 = responsibleGamingAlert[0];
                            }
                            else {
                                message_1 = messagesToShow[0];
                            }
                            hasModalOpen = true;
                            if (this.openMessageId === message_1.id) {
                                return [2 /*return*/];
                            }
                            this.closeModal();
                            isPopOpen = message_1.priority === MessagePriority.POP_OPEN;
                            shouldUseNotification = isPopOpen &&
                                isMobile &&
                                useModalsOnMobile &&
                                !hasResponsibleGamingAlert;
                            if (shouldUseNotification) {
                                notificationElement = createElement('magic-message');
                                notificationElement.message = message_1;
                                notificationElement.hideBacklink = true;
                                overlay = this.createOverlay();
                                overlay.addEventListener('click', function () {
                                    notificationService.close(notification_1);
                                });
                                notificationElement.addEventListener('ctaClicked', function (event) {
                                    notificationService.close(notification_1);
                                    _this.confirm(message_1);
                                    _this.removeOverlay();
                                });
                                notification_1 = notificationService.show(notificationElement, {
                                    dismissible: true,
                                    style: NotificationStyle.POP_MODAL,
                                    uniqueID: "osm-message-" + message_1.id,
                                    closeDelay: NotificationDelay.PERMANENT,
                                    onClose: function () {
                                        _this.confirm(message_1);
                                        _this.removeOverlay();
                                    },
                                });
                                this.openMessageId = message_1.id;
                            }
                            else if (hasResponsibleGamingAlert) {
                                modalElement = this.openModal(this.renderedModal, this.header || null, { dismissible: false });
                                modalElement.message = message_1;
                                modalElement.hideBacklink = true;
                                modalElement.addEventListener('acknowledged', function () {
                                    _this.closeModal();
                                    _this.acknowledge(message_1);
                                });
                                modalElement.addEventListener('ctaClicked', function (event) {
                                    _this.closeModal();
                                    _this.visitedUrl(message_1, event.detail[0]);
                                });
                                this.openMessageId = message_1.id;
                            }
                            else {
                                modalElement = this.openModal(this.renderedModal, this.header || null, {
                                    dismissible: true,
                                    keepAfterClear: true,
                                    onClose: function () {
                                        _this.confirm(message_1);
                                    },
                                });
                                modalElement.message = message_1;
                                modalElement.hideBacklink = true;
                                modalElement.addEventListener('ctaClicked', function (event) {
                                    _this.closeModal();
                                });
                                this.openMessageId = message_1.id;
                            }
                        }
                        if (!hasModalOpen) {
                            // Close any modals that no longer need prompting (eg. Cross tab alert).
                            this.closeModal();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MessagePrompterComponent.prototype.onSessionChange = function (isLoggedIn) {
        if (!isLoggedIn) {
            this.closeModal();
        }
    };
    MessagePrompterComponent.prototype.render = function () {
        return null;
    };
    /**
     * Emits the message ID of the message that was acknowledged.
     * @param message The message to be acknowledged
     */
    MessagePrompterComponent.prototype.acknowledge = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var language, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        language = magicConfig.language;
                        if (!this.isCoreX) return [3 /*break*/, 2];
                        return [4 /*yield*/, magic.methods.users.acknowledgeMessage({
                                messageID: message.id,
                                lang: language,
                            })];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = magic.methods.users.addNote("User acknowledged at " + new Date().toISOString() + " UTC: " + message.subject);
                        _b.label = 3;
                    case 3:
                        this.confirm(message);
                        return [2 /*return*/, message.id];
                }
            });
        });
    };
    MessagePrompterComponent.prototype.visitedUrl = function (message, cta) {
        var url = cta === 'primary' ? message.url : message.url2;
        magic.methods.users.addNote("User visited " + url + " page at " + new Date().toISOString() + " UTC: " + message.subject);
        this.confirm(message);
    };
    /**
     * Archives the message or mark it as read based on the message ID.
     * @param message The message to be read.
     */
    MessagePrompterComponent.prototype.confirm = function (message) {
        var _this = this;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, 6, 7]);
                        if (!message.once) return [3 /*break*/, 2];
                        return [4 /*yield*/, magic.methods.messages.archive(message.id)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, magic.methods.messages.markAsRead(message.id)];
                    case 3:
                        _a.sent();
                        this.messageRead(message.id);
                        _a.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        err_1 = _a.sent();
                        // Ignore the error as the user cannot do anything about it
                        // and it's not important (the message it's simply not marked
                        // as read)
                        console.error(err_1);
                        return [3 /*break*/, 7];
                    case 6:
                        this.openMessageId = '';
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); })();
    };
    MessagePrompterComponent.prototype.messageRead = function (id) {
        return { id: id, isPopOpen: true };
    };
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        }),
        __metadata("design:type", Boolean)
    ], MessagePrompterComponent.prototype, "shouldDisableAlerts", void 0);
    __decorate([
        Prop({
            type: String,
            default: 'magic-message',
        }),
        __metadata("design:type", String)
    ], MessagePrompterComponent.prototype, "renderedModal", void 0);
    __decorate([
        Prop({
            type: String,
            default: null,
        }),
        __metadata("design:type", Object)
    ], MessagePrompterComponent.prototype, "header", void 0);
    __decorate([
        Watch('shouldDisableAlerts'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], MessagePrompterComponent.prototype, "onDisableAlertsChange", null);
    __decorate([
        SessionChange({ immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], MessagePrompterComponent.prototype, "onSessionChange", null);
    __decorate([
        Emit('acknowledge'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], MessagePrompterComponent.prototype, "acknowledge", null);
    __decorate([
        Emit('message-read'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Object)
    ], MessagePrompterComponent.prototype, "messageRead", null);
    MessagePrompterComponent = __decorate([
        Component({
            name: 'message-prompter',
        })
    ], MessagePrompterComponent);
    return MessagePrompterComponent;
}(Mixins(MagicConfigMixin, ModalMixin)));

export { MessagePrompterComponent };
